/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import { ENDPOINTS, parseApiError, restClient } from '../../../../../../interface/api';
import { EVALUATIONS_STRINGS as STRINGS } from './evaluations.strings';
import type { EvaluationsPage, EvaluationsQuery } from './evaluations.types';

const VIOLATIONS_PARAM: Record<'with' | 'without', string> = { with: 'true', without: 'false' };

/** Lists are sent as repeated parameters, which is what the backend expects. */
export function buildEvaluationsParams(query: EvaluationsQuery): URLSearchParams {
  const params = new URLSearchParams();
  for (const format of query.formats) params.append('format', format);
  for (const level of query.threatLevels) params.append('threatLevel', level);
  if (query.violations) params.set('withViolations', VIOLATIONS_PARAM[query.violations]);
  const search = query.search.trim();
  if (search) params.set('search', search);
  params.set('sortBy', query.sortBy);
  params.set('asc', String(query.asc));
  params.set('page', String(query.page));
  params.set('pageSize', String(query.pageSize));
  return params;
}

export async function fetchEvaluations(query: EvaluationsQuery): Promise<EvaluationsPage> {
  try {
    return await restClient.get<EvaluationsPage>(
      `${ENDPOINTS.FIREWALL_EVALUATIONS}?${buildEvaluationsParams(query).toString()}`
    );
  } catch (error) {
    // The backend answers IQ failures with a fixed message (IQ not configured, unreachable, unsupported, error).
    throw new Error(parseApiError(error).message || STRINGS.errors.loadList);
  }
}
